import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-14b.svg'

const data = {
  question:
    'There are different risks and consequences associated with vaping/using e-cigarettes. Jacob’s friend told him he could no longer spend the night at his house because his parents saw Jacob vaping. Which type of risk or consequence would this be an example of?',
  inputType: 'radio',
  options: [
    {
      label: 'health risk',
    },
    {
      label: 'financial consequence',
    },
    {
      label: 'addiction risk',
    },
    {
      label: 'social consequence',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[3].label,
}

const feedback = {
  success: {
    title: 'Nice job!',
    body: '',
  },
  error: {
    title: 'That is not correct.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 2',
  path: '/challenge/question-2',
  content: (
    <Fragment>
      <Intro title="Question 2" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question2.js